import React, { useState, useEffect } from "react";

const Rules = () => {
    const [discountCode, setDiscountCode] = useState("");
    const [message, setMessage] = useState("");
    const [discountCodes, setDiscountCodes] = useState([]);

    // Fetch all discount codes in the price rule
    const fetchDiscountCodes = async () => {
        try {
            const response = await fetch("https://bymolive-backend-995926394015.us-central1.run.app/api/get-discount-codes");
            if (!response.ok) {
                throw new Error("Failed to fetch discount codes.");
            }
            const data = await response.json();
            setDiscountCodes(data.discount_codes || []);
        } catch (error) {
            console.error("Error fetching discount codes:", error.message);
        }
    };

    useEffect(() => {
        fetchDiscountCodes();
    }, []);

    const handleCreateDiscount = async () => {
        if (!discountCode.trim()) {
            setMessage("Please enter a discount code.");
            return;
        }

        try {
            const response = await fetch("https://bymolive-backend-995926394015.us-central1.run.app/api/create-discount", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ discount_code: discountCode }),
            });

            if (!response.ok) {
                throw new Error("Failed to create the discount code.");
            }

            const data = await response.json();
            setMessage(`Success: ${data.message}`);
            setDiscountCode(""); // Clear input after success
            fetchDiscountCodes(); // Refresh discount codes list
        } catch (error) {
            setMessage(`Error: ${error.message}`);
        }
    };

    return (
        <div style={{ padding: "20px" }}>
            <h1>Create Discount Code</h1>
            <input
                type="text"
                placeholder="Enter discount code"
                value={discountCode}
                onChange={(e) => setDiscountCode(e.target.value)}
                style={{
                    padding: "10px",
                    marginRight: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                }}
            />
            <button
                onClick={handleCreateDiscount}
                style={{
                    padding: "10px 20px",
                    backgroundColor: "#4caf50",
                    color: "#fff",
                    border: "none",
                    borderRadius: "5px",
                    cursor: "pointer",
                }}
            >
                Send
            </button>
            {message && (
                <p
                    style={{
                        marginTop: "20px",
                        color: message.startsWith("Error") ? "red" : "green",
                    }}
                >
                    {message}
                </p>
            )}

            <h2>Existing Discount Codes</h2>
            {discountCodes.length > 0 ? (
                <ul>
                    {discountCodes.map((code) => (
                        <li key={code.id}>
                            {code.code} (Created: {new Date(code.created_at).toLocaleString()})
                        </li>
                    ))}
                </ul>
            ) : (
                <p>No discount codes found.</p>
            )}
        </div>
    );
};

export default Rules;
